export default "__VITE_ASSET__TRPM2PA3__"